/**
 * this is the right menu for the dashboard
 *
 * Created by Tom on 1/6/18
 */

import React, {Component} from 'react'
import PropTypes from 'prop-types'
import {bindActionCreators} from 'redux'
import {connect} from 'react-redux'
import cx from 'classnames'
import Parser from 'html-react-parser'
import {isEmpty} from '../../utility/utilities'

// action import
import {ActionCreator} from '../../actions/'

// component import
import SimpleLoader from '../SimpleLoader'

// style import
import './style.scss'

// icon imports
import BellIcon from '../../assets/svg/bell.svg'
import CloseIcon from '../../assets/svg/close.svg'
import CongratsImg from '../../assets/svg/congrats.svg'
import SpeakImg from '../../assets/svg/speak_directly.svg'
import ReferralImg from '../../assets/svg/referral.svg'
import IdeaImg from '../../assets/svg/dollar-idea.svg'
import GreenTick from '../../assets/svg/green_tick.svg'

import AppButton from '../AppButton'
import Popup from "reactjs-popup";

class RightMenu extends Component {

    constructor(props) {
        super(props)

        this.state = { email: '' }
    }

    _onOpenMenu() {
        const {setOpenRightMenu} = this.props
        // open the left menu
        setOpenRightMenu(true)
    }

    _onCloseMenu() {
        const {setOpenRightMenu} = this.props
        // close the left menu
        setOpenRightMenu(false)
    }

    _onCloseCongratsInfoBox() {
        const {setOpenCongratsInfoBox, dismissNotificationRequest, congratulate_message} = this.props
        const congratsId = congratulate_message.id

        //close the congratulation info box
        setOpenCongratsInfoBox(false)

        // Call api to dismiss this notification
        dismissNotificationRequest(congratsId)
    }

    handleChange (e) {
        this.setState({
            email: e.target.value
        })
    }
    
    _onSendReferralEmail() {
        
        const {sendReferralRequest,setReferralResponse,profile} = this.props
        
        if (this.state.email !== '') {
            
            let details = {
                id: profile.id,
                email_string: this.state.email
            }

            setReferralResponse('')
            sendReferralRequest(details)
        }
    }

    componentDidMount() {
        const {setOpenRightMenu, breakPointObj, getProfileData} = this.props
        breakPointObj.greaterThan.large &&  setOpenRightMenu(true)

        // Fetch data
        getProfileData()
    }

    renderCongrats() {
        const {congratulate_message} = this.props
        if (isEmpty(congratulate_message)) return

        const {openCongratsInfo} = this.props
        const {title, sub_title, description} = congratulate_message;

        return (openCongratsInfo &&
            <div className="right-menu__top-container">
                <a
                    className="right-menu__top-container__close-text"
                    onClick={::this._onCloseCongratsInfoBox}>
                    Close
                </a>
                <div className="right-menu__wrapper">
                    <div className="right-menu__wrapper-left">
                        <img
                            src={CongratsImg}
                            alt="Man on top podium"/>
                    </div>
                    <div className="right-menu__wrapper-right">
                        <p className="right-menu__header-text">
                            {title}
                        </p>
                        <p className="right-menu__info-bold">
                            {sub_title}
                        </p>
                        <div className="right-menu__info-text">
                            {Parser(description)}
                        </div>
                    </div>
                </div>
            </div>)
    }

    renderNews() {
        const {news_items} = this.props
        if (isEmpty(news_items)) return

        return (
            <React.Fragment>
                {news_items.map(item => {
                    const id = item.id
                    const img = item.image || SpeakImg
                    const title = item.title
                    const description = item.description

                    return (
                        <div className="right-menu__bottom-container" key={id}>
                          <div className="right-menu__wrapper">
                              <div className="right-menu__wrapper-left">
                                  <img src={img} alt="" />
                              </div>
                              <div className="right-menu__wrapper-right">
                                  <p className="right-menu__header-text">
                                      {title}
                                  </p>
                                  <div className="right-menu__info-text">
                                      {Parser(description)}
                                  </div>
                              </div>
                          </div>
                      </div>
                    )
                })}
            </React.Fragment>
        )
    }

    renderReferral() {

        const {isEmailing, referralResponse, profile} = this.props

        let isDemo = false
        if (profile['email'] == 'demo+1865@selfmade.com.au') {
            isDemo = true
        }
        if (isDemo) return

        let title = 'Refer a Friend'
        let description = 'Receive 15% off your yearly membership fees for a successful referral.'
        
        return (

            <div className="right-menu__referral-container">
                
                <div className="right-menu__wrapper">
                    <div className="right-menu__wrapper-left">
                        <img
                            src={IdeaImg}
                            alt="Documents"/>
                    </div>
                    <div className="right-menu__wrapper-right">
                        <p className="right-menu__header-text">
                            {title}
                        </p>
                        <div className="right-menu__info-text">
                            {Parser(description)}
                            <Popup
                                trigger={<span className="tooltip-link">More Info?</span>} position="bottom center"
                                contentStyle={{ width: '300px', padding: '20px' }}
                                >
                                <div>
                                    <div className="popup-data"> 
                                        <p>Refer a friend to Selfmade, and if they on-board successfully,
                                        you are both eligible to receive 15% off your yearly membership fees for
                                        12 months. Discount is applied from next calendar month following successful
                                        set up of fund.</p>
                                    </div>
                                </div>
                            </Popup>
                        </div>
                        <div className="right-menu__info-text">
                            
                            <input onChange={(e) => {this.handleChange(e)}} className={'right-menu__referral-container--input' + (referralResponse === 'INVALID' ? ' invalid-email' : '')} type="text" placeholder="friend@example.com" />
                            
                            <div className="right-menu__referral-container--button">
                                <button disabled={isEmailing} className={'app-button app-button--small app-button--blue loading-spinner' + (isEmailing ? '' : ' loading-spinner--hide')} onClick={ () => this._onSendReferralEmail() }>Send Referral
                                    {referralResponse === 'SUCCESS' &&
                                        <img
                                            src={GreenTick}
                                            className="right-menu__referral-container--success"
                                            alt="Email Sent Successfully"/>
                                    }
                                </button>
                            </div>

                        </div>
                    </div>
                </div>
            </div>)
    }

    render() {
        const {openRightMenu, isLoading} = this.props

        // switch on/off classes based on the truthy value 'openRightMenu'
        const dynClass = cx('right-menu-container', {'right-menu-container--open': openRightMenu})

        return (
            <div className="right-menu-container-wrapper">
                <div
                    className="right-menu-open-container"
                    onClick={::this._onOpenMenu}>
                    <img
                        src={BellIcon}
                        className="right-menu-open-container__icon"
                        alt="Left menu close icon"/>
                </div>
                <div className={dynClass}>
                    <div className="right-menu-wrapper">
                        <div
                            className="right-menu-container__close-container"
                            onClick={::this._onCloseMenu}>
                            <img
                                src={CloseIcon}
                                className="right-menu-container__close-icon"
                                alt="Left menu close icon"/>
                        </div>
                        <div className="right-menu">
                            <SimpleLoader
                                num={2}
                                show={isLoading}
                                darkMode
                            />

                            {/* referral link */}
                            {this.renderReferral()}

                            {/* congrats info box */}
                            {this.renderCongrats()}



                            {/* bottom info container */}
                            {this.renderNews()}
                        </div>
                    </div>
                </div>
            </div>
        )
    }
}

// define the prop types
RightMenu.propTypes = {
    setOpenRightMenu: PropTypes.func.isRequired,
    setOpenCongratsInfoBox: PropTypes.func.isRequired,
    openRightMenu: PropTypes.bool,
    openCongratsInfo: PropTypes.bool,
    breakPointObj: PropTypes.object,
    profile: PropTypes.object,
}

// pull props to this container
const mapStateToProps = (state) => {
    return {
        openRightMenu: state.componentState.openRightMenu,
        openCongratsInfo: state.componentState.openCongratsInfo,
        breakPointObj: state.browser,
        isEmailing: state.referralState.isEmailing,
        referralResponse: state.referralState.response,
        profile: state.profileState.data,
    }
}

// pull all required action creators into this container
const mapDispatchToProps = (dispatch) => {
    const action = bindActionCreators(ActionCreator, dispatch)
    return {
        setOpenRightMenu: action.setOpenRightMenu,
        setOpenCongratsInfoBox: action.setOpenCongratsInfoBox,
        sendReferralRequest: action.sendReferralRequest,
        setReferralResponse: action.setReferralResponse,
        getProfileData: action.getProfileData,
    }
}

export default connect(mapStateToProps, mapDispatchToProps)(RightMenu)



// WEBPACK FOOTER //
// ./src/components/RightMenu/index.js